import { ColumnTypeEnum } from "src/app/core/enums/list-layout/column-type-enum";
import { GlobalComponent } from "src/app/global-component";
import { TableConfigurationModel } from "src/app/core/models/table/table-configuration.model";
import { SortByValuesModel } from "src/app/core/models/table/sort-by-values.model";
import { EntityTypeEnum } from "src/app/core/enums/entity-type-id-enum";
import { PaymentType } from "src/app/core/enums/payment-type-enum";

export class PaymentListConfig extends TableConfigurationModel {

     constructor() {
        super();
        this.listTitle = "Payment History";
        this.pageSizeFilter = [
            { pageSize: GlobalComponent.defaultPagingInfo.pageSize },
            { pageSize: 25 },
            { pageSize: 50 }
        ]
        this.columns = [

            {

                dataFieldName: 'description',
                title: 'Invoice',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 0,
                width: "250px",
                type: ColumnTypeEnum.String,
                underTextDataFieldName: 'type',
                imageUrlLink: true
            },
            {
                dataFieldName: 'paymentType',
                title: 'Type',
                sortable: new SortByValuesModel('createdDate'),
                visible: 'true',
                order: 1,
                width: "150px",
                type: ColumnTypeEnum.StatusCustom,
                customStatusText: {
                    type: EntityTypeEnum,
                    switchOptions: [
                        { case: PaymentType.Credit, return: 'Credit' },
                        { case: PaymentType.PartialRefund, return: 'Partial Refund' },
                        { case: PaymentType.Refund, return: 'Refund' },
                        { case: undefined, return: 'Other' }
                    ]
                }
            },


            {
                dataFieldName: 'createdDate',
                title: 'Date Created',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 2,
                width: "120px",
                type: ColumnTypeEnum.Date,
            },
            {
                dataFieldName: 'amount',
                title: 'Amount',
                visible: 'true',
                order: 3,
                width: "100px",
                type: ColumnTypeEnum.Amount,

            }
        ]
        this.searchbarFilter = undefined;

        this.filters = undefined;

        this.actions = [];

        this.buttons = [];
    }
}